<template>
  <v-color-picker
    v-bind="{ ...$attrs, ...commonAttrs }"
    v-on="$listeners"
  />
</template>

<script>
export default {
  name: 'ColorPicker',
  computed: {
    commonAttrs() {
      return {
        hideDetails: this.$attrs.hideDetails || 'auto',
        mode: 'hexa',
      }
    }
  }
}
</script>